import { render } from "./TenderCard.vue?vue&type=template&id=1b69e36b&ts=true"
import script from "./TenderCard.vue?vue&type=script&lang=ts"
export * from "./TenderCard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/anton/Projects/python/tender_asia/components/tender_asia_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__